import styled from 'styled-components';

export const ExcursionPublicDetailsPageContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f5f5;
`;
